<template>
  <div class="margin">
    <br />
    <Button v-if="id" _key="btnSupplierOrderCreate" title="Pedido de Fornec..." classIcon="fas fa-plus-circle"
      type="primary" size="small" eventName="supplierOrderCreate" :clicked="newSupplierOrder" />
    <DropdownOptionsSupplierOrder v-if="id" :supplierOrder="supplierOrder" />
    <br />
    <div v-if="id">
      <br />
      <b-row>
        <b-col sm="5">
          <Badge :title="'Nº' + supplierOrder.number.toString()" type="primary" size="medium" />
          <Badge :title="status.title" :type="status.type" size="small" />
          <span v-if="supplierOrder.archived" class="span-archived"><i class="fa-solid fa-box-archive"
              style="color:#453DB4"></i></span>
        </b-col>
      </b-row>
      <br />
      <DisplayTotalization title="Total" :value="supplierOrder.total" />
      <Alert
        v-if="supplierOrder.total.toFixed(2) != supplierOrder.totalPayment.toFixed(2) && status.title == 'Aprovada'"
        type="warning">
        <span>
          Atenção, o valor total <b> {{ supplierOrder.total | currency }} </b> está diferente do total de
          pagamento <b>{{ supplierOrder.totalPayment | currency }}</b>!
        </span>
      </Alert>
    </div>
    <Molded>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="4">
          <InputText title="Identificação" field="name" :formName="formName" :required="false" :maxLength="100"
            v-model="supplierOrder.identification" />
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="12" xl="4">
          <Select title="Solicitado por" field="type" :formName="formName" :required="true" :disabled="disabled"
            url="/api/v1/human-resources/collaborator/select-all" :propsParams="{ isConsultant: true }"
            v-model="supplierOrder.collaborator" nameNewRegister="consultantCreateUpdate"
            :showNewRegister="hasRule('HumanResources')" titleNewRegister="Consultor" :widthNewRegister="800"
            :heightNewRegister="250">
            <ConsultantCreateUpdate :registerInSelect="true" v-model="supplierOrder.collaborator" />
          </Select>
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="12" xl="4">
          <Select title="Locação Vinculada" field="type" :formName="formName" :required="false"
            url="api/v1/rental/rent/select-all" v-model="supplierOrder.rent" :showNewRegister="false"
            :heightNewRegister="250">
          </Select>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="8">
          <SupplierWithCreate :formName="formName" v-model="supplierOrder.customer" />
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="12" xl="4">
          <Select title="Contato" field="type" :formName="formName" :required="true"
            :disabled="!supplierOrder.customer.id" url="/api/v1/shared/contact/select-all"
            :propsParams="{ any: supplierOrder.customer.id }" v-model="supplierOrder.contact"
            nameNewRegister="contactCreateUpdate" :showNewRegister="true" titleNewRegister="Contato"
            :widthNewRegister="750" :heightNewRegister="250">
            <ContactCreateUpdate :registerInSelect="true" :customerSupplierId="supplierOrder.customer.id"
              v-model="supplierOrder.contact" />
          </Select>
        </b-col>
      </b-row>
      <div class="launch-products">
        <!-- <CheckboxSimple title="Lançar produtos sublocados temporariamente ao estoque"
          v-model="supplierOrder.launchProducts" /> -->
        <b-row v-if="supplierOrder.launchProducts">
          <b-col sm="2">
            <DateTime title="Saída" field="deliveryDateHour" format="DD/MM/YYYY HH:mm" type="dateTime" placeholder
              :formName="formName" :required="true" v-model="supplierOrder.deliveryDateHour" />
          </b-col>
          <b-col sm="2">
            <DateTime title="Inicio" field="startDateHour" format="DD/MM/YYYY HH:mm" type="dateTime" placeholder
              :formName="formName" :required="true" v-model="supplierOrder.startDateHour" />
          </b-col>
          <b-col sm="2">
            <DateTime title="Fim" field="endDateHour" format="DD/MM/YYYY HH:mm" type="dateTime" placeholder
              :formName="formName" :required="true" v-model="supplierOrder.endDateHour" />
          </b-col>
          <b-col sm="2">
            <DateTime title="Retorno" field="devolutionDateHour" format="DD/MM/YYYY HH:mm" type="dateTime" placeholder
              :formName="formName" :required="true" v-model="supplierOrder.devolutionDateHour" />
          </b-col>
        </b-row>
      </div>
    </Molded>
    <br />
    <Tab v-if="id" v-model="tabIndex" :initialTabs="tabsByModule">
      <div :slot="0">
        <ItemsSupplierOrderList v-show="tabIndex == 0" :supplierOrder="supplierOrder" />
      </div>
      <div :slot="1">
        <PaymentSupplierOrderList v-if="tabIndex == 1" :status="supplierOrder.status"
          :supplierOrderId="supplierOrder.id" />
      </div>
      <div :slot="2">
        <EditorHtml title="Observações" field="observation" :required="false" :maxLength="3000"
          v-model="supplierOrder.observation" />
      </div>
      <div :slot="3">
        <TimelineLog v-if="tabIndex == 3" :id="id" />
      </div>
    </Tab>
  </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Badge from "@nixweb/nixloc-ui/src/component/layout/Badge.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded.vue";
import Tab from "@nixweb/nixloc-ui/src/component/layout/Tab.vue";
import TextArea from "@nixweb/nixloc-ui/src/component/forms/TextArea";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import EditorHtml from "@nixweb/nixloc-ui/src/component/forms/EditorHtml";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import DisplayTotalization from "@nixweb/nixloc-ui/src/component/rental/DisplayTotalization";
import DropdownOptionsSupplierOrder from './DropdownOptionsSupplierOrder.vue'

import SupplierWithCreate from '../shared/SupplierWithCreate.vue'
import ConsultantCreateUpdate from '../../human-resources/collaborator/ConsultantCreateUpdate.vue'
import ContactCreateUpdate from '../../shared/contact/ContactCreateUpdate.vue'
import ItemsSupplierOrderList from '../items-supplier-order/ItemsSupplierOrderList.vue'
import PaymentSupplierOrderList from '../payment-supplier-order/PaymentSupplierOrderList.vue'
import TimelineLog from '../../adm/audit-log/TimelineLog.vue'

import SupplierOrder from "@/components/modules/supplier/supplier-order/SupplierOrder.js";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "SupplierOrderCreateUpdate",
  components: {
    Alert,
    Badge,
    Select,
    TextArea,
    Molded,
    Tab,
    CheckboxSimple,
    InputText,
    Modal,
    DateTime,
    Button,
    EditorHtml,
    DisplayTotalization,
    ConsultantCreateUpdate, SupplierWithCreate, ContactCreateUpdate, DropdownOptionsSupplierOrder, ItemsSupplierOrderList, PaymentSupplierOrderList, TimelineLog
  },
  data() {
    return {
      id: this.$route.params.id,
      formName: "supplierOrderCreateUpdate",
      supplierOrder: new SupplierOrder(),
      urlCreate: "/api/v1/supplier/supplier-order/create",
      urlUpdate: "/api/v1/supplier/supplier-order/update",
      urlGetById: "/api/v1/supplier/supplier-order/get-by-id",
      tabIndex: 0,
      tabs: [
        { index: 0, title: "Produto" },
        { index: 1, title: "Pagamento" },
        { index: 2, title: "Observações" },
        { index: 3, title: "Auditoria" },
      ],
    };
  },
  created() {
    if (this.id) {
      this.getById();
      this.tabIndex = 0;
    }
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event", "showModal", "isLoading"]),
    ...mapGetters("user", ["hasModule", "hasRule"]),
    status() {
      if (this.supplierOrder.status == 1)
        return { title: "Orçamento", type: "info" };

      if (this.supplierOrder.status == 2)
        return { title: "Aprovada", type: "success" };

      if (this.supplierOrder.status == 3)
        return { title: "Reprovada", type: "danger" };
    },
    tabsByModule() {
      let tabs = [];
      var isAudit = this.hasRule("Audit");
      var isUserTemp = this.userLogged.user.userName === "UserTemp";


      this.tabs.forEach((tab) => {
        if (tab.title === "Auditoria" && (isAudit || isUserTemp)) {
          tabs.push(tab);
        }
        if (tab.title != "Auditoria") tabs.push(tab);
      });
      return tabs;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi", "getApi"]),
    ...mapMutations("generic", [
      "addEvent",
      "removeLoading",
      "openModal",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation", "removeFormDirty"]),
    create() {
      let params = { url: this.urlCreate, obj: this.supplierOrder };
      this.postApi(params).then((response) => {
        if (response.success)
          this.$router.replace({
            name: "supplierOrderUpdate",
            params: { id: response.content.id, type: response.content.type },
          });
        this.removeLoading(["saveSaveCancel"]);
      });
    },
    update() {
      let params = { url: this.urlUpdate, obj: this.supplierOrder };
      this.putApi(params).then((response) => {
        if (response.success) {
          let self = this;
          setTimeout(function () {
            self.addEvent({ name: "updateTotalizationRent" });
          }, 100);
        }
        this.removeLoading(["saveSaveCancel"]);
      });
    },
    getById() {
      let params = { url: this.urlGetById, obj: { id: this.id } };
      this.getApi(params).then((response) => {
        this.supplierOrder.update(response.content);
        let self = this;
        setTimeout(function () {
          self.removeLoading(["panel"]);
          self.removeFormDirty();
        }, 100);
      });
    },
    newSupplierOrder() {
      let self = this;
      setTimeout(function () {
        self.$router.push({
          name: "supplierOrderCreate",
        });
        self.removeLoading(["btnSupplierOrderCreate"]);
      }, 200);
    },
  },
  watch: {
    event: {
      handler(event) {
        let name = event.name;
        if (name == "saveSaveCancel") {
          if (!this.id) this.create();
          if (this.id) this.update();
        }

        const eventsToReload = [
          "paymentSupplierUpdated",
          "itemsRemoved",
          "supplierOrderAccepted",
          "supplierOrderProcessed",
          "supplierOrderRejected",
          "supplierOrderArchive",
          "updateProduct",
          "addedProduct"
        ];

        if (eventsToReload.includes(name)) {
          this.getById();
        }

      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.launch-products {
  margin-top: 15px;
}

.span-archived {
  margin-left: 10px;
}
</style>
